import { JobReadinessItemDto } from './JobReadinessItemDto';
import { JobReadinessStatus } from './JobReadinessStatus';

/**
 * Result of a single job-readiness check (one row in the readiness dialog).
 * `MissingItems` names the exact setup gaps so the user can fix them at entry
 * time instead of discovering them at export.
 */
export interface JobReadinessCheckDto {
  CheckKey: string;
  Status: JobReadinessStatus;
  MissingItems: string[];
  Message: string;
  /** US 37167: the lines behind the check (the Labor check only); absent for setup checks. */
  Items?: JobReadinessItemDto[] | null;
}
